import { Component, effect, OnDestroy, Signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconComponent } from '../icon/icon.component';
import { DatePickerModule } from 'primeng/datepicker';
import { NotificationsModalComponent } from '../../modals/notifications-modal/notifications-modal.component';
import { MenuService } from '../menu/services/menu.service';
import { ParamsService } from '../../services/params/params.service';
import { ThemeService } from '../../services/theme/theme.service';
import { ThemeEnum } from '../../services/theme/models/enums/theme.enum';
import { ActivatedRoute, Data, NavigationEnd, Router } from '@angular/router';
import { MeService } from '../../services/me/me.service';
import { AuthService } from '../../services/auth/auth.service';
import { filter, map, Subscription, switchMap } from "rxjs";
import { User } from '../../models/interfaces/user.interface';
import { ModalService } from '../../services/modal/modal.service';
import { createCancelConfirmButtons, openConfirmModal } from '../../../helpers/modal.helper';
import { ButtonTypeEnum } from '../button/types/button-type.enum';

@Component({
    selector: 'l-header',
    standalone: true,
    templateUrl: './header.component.html',
    imports: [
      IconComponent,
      FormsModule,
      DatePickerModule,
      NotificationsModalComponent,
    ]
})
export class HeaderComponent implements OnDestroy {

  constructor(
    router: Router,
    route: ActivatedRoute,
    private readonly meService: MeService,
    private readonly menuService: MenuService,
    private readonly authService: AuthService,
    private readonly modalService: ModalService,
    private readonly themeService: ThemeService,
    private readonly paramsService: ParamsService,
  ) {
    effect(() => {
      const params = this.paramsService.params();
      this.inputValue = params.search || '';
    })

    this.routerSubscription = router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => route),
      map(route => {
        while (route.firstChild)
          route = route.firstChild;

        return route;
      }),
      switchMap(route => route.data)
    ).subscribe((data: Data) => {
      this.search = data['search'] !== undefined ? !!data['search'] : true;
    });
  }

  public timer: any;

  public inputValue: string = '';

  public open: boolean = false;

  public search: boolean = true;

  public selectedMonthDate: Date = new Date();

  public notificationsOpen: boolean = false;

  public shortMode: Signal<boolean> = this.menuService.short;

  public theme: Signal<ThemeEnum> = this.themeService.theme;

  public me: Signal<User | null> = this.meService.me;

  protected readonly themeEnum = ThemeEnum;

  protected readonly routerSubscription: Subscription;

  public ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  public toggleTheme(): void {
    this.themeService.theme = this.theme() === ThemeEnum.DARK ? ThemeEnum.LIGHT : ThemeEnum.DARK;
  }

  public setShortMode(): void {
    this.menuService.short = false;
  }

  public async setSearch(): Promise<void> {
    this.paramsService.params = {
      search: this.inputValue,
    };
  }

  public toggleNotifications(): void {
    this.notificationsOpen = !this.notificationsOpen;
  }

  public closeNotifications(): void {
    this.notificationsOpen = false;
  }

  public logout(): void {
    openConfirmModal(
      this.modalService,
      'fit-content',
      {
        title: 'Sair da conta',
        description: 'Tem certeza que deseja encerrar sua sessão?',
        buttons: createCancelConfirmButtons('Sair', ButtonTypeEnum.DANGER),
      },
      async () => {
        await this.authService.logout();
      },
    );
  }

  public get selectedMonthLabel(): string {
    const monthName = this.selectedMonthDate.toLocaleDateString('pt-BR', { month: 'long' });
    const capitalizedMonthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);
    const year = this.selectedMonthDate.getFullYear();

    return `${capitalizedMonthName}, ${year}`;
  }

}
